import { ComponentType } from '../../../../common';
export const checkZeroWidthSpaceText = text => {
  return text.charCodeAt(0) === 8203;
};
export const checkEmptyTextAndZeroWidth = paragraph => {
  var _paragraph$textConten;
  const text = ((_paragraph$textConten = paragraph.textContent) == null ? void 0 : _paragraph$textConten.trim()) || '';
  return !text || checkZeroWidthSpaceText(text) ? null : text;
};
export const getTextParagraphs = html => {
  const paragraphs = htmlToElement(html);
  return paragraphs.childNodes;
};
export const htmlToElement = html => {
  const template = document.createElement('template');
  template.innerHTML = html.trim();
  return template.content;
};
export const getTextComponentColorSpan = node => {
  const child = node == null ? void 0 : node.firstElementChild;
  if (!child) {
    return;
  }
  if (child.style.color) {
    return child;
  }
  const color = Array.from(child.classList).find(isColorPaletteKey);
  if (color) {
    return child;
  }
  return getTextComponentColorSpan(child);
};
export function isColorPaletteKey(key) {
  return /^color_[\d]{1,2}$/.test(key);
}
export const elementsListToHtml = nodeList => {
  const template = document.createElement('div');
  nodeList.forEach(node => template.appendChild(node));
  return template.innerHTML;
};
export const getTextComponentBackgroundSpan = node => {
  const child = node.firstElementChild;
  if (!child) {
    return;
  }
  if (child.style.backgroundColor) {
    return child;
  }
  const [backgroundClass] = Array.from(child.classList).filter(nodeClass => nodeClass.startsWith('backcolor_'));
  if (backgroundClass) {
    return child;
  }
  return getTextComponentBackgroundSpan(child);
};
export function isPageComponent(component) {
  return component.type === ComponentType.Page && Boolean(component.id) && component.data.type === 'Page';
}
//# sourceMappingURL=utils.js.map